import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";


const departmentApi = createApi({
    reducerPath: "base/department",
    baseQuery: axiosBaseQuery,
    tagTypes: ["departmentList"],
    endpoints: (builder) =>({
        departmentFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['departmentList'],
            query: (query = '') => ({
                url: "/base/department" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        departmentCreate: builder.mutation({
            invalidatesTags: ['departmentList'],
            query: (data)=>({url: "/base/department", method: "POST", data})
        }),
        departmentUpdate: builder.mutation({
            invalidatesTags: ['departmentList'],
            query: (data)=>({url: "/base/department/"+data.id, method: "PUT", data})
        }),
        departmentDelete: builder.mutation({
            invalidatesTags: ['departmentList'],
            query: (id)=>({url: "/base/department/"+id, method: "DELETE"})
        }),
    })
})

export const { useDepartmentFindAllQuery, useDepartmentCreateMutation, useDepartmentUpdateMutation, useDepartmentDeleteMutation } = departmentApi;
export {departmentApi};
